<template>
    <div class="node-properties-inner">
        <selector :options="[
            { label: 'Solid', value: 'solid' },
            { label: 'Border', value: 'border' }]" v-model="properties.kind" />
        <label>Outer</label>
        <input v-model.number="properties.outerDistance">
        <label class="units">m</label>
        <template v-if="properties.kind == 'border'">
            <label>Inner</label>
            <input v-model.number="properties.innerDistance">
            <label class="units">m</label>
        </template>
    </div>
</template>

<script>
import Selector from "@/components/nodes/Selector.vue";

export default {
    props: {
        properties: { type: Object, required: true }
    },
    components: { Selector }
}
</script>

<style lang="less" scoped>
</style>